<template>
  <b-container fluid class="h-100">
    <b-row class="h-100">
      <b-col sm="12">
        <card class="pb-5">
          <template v-slot:headerTitle>
            <div class="d-flex justify-content-between w-100">
              <h3 class="card-title font-weight-bold" style="font-size: 30px">{{ TituloEvaluacion }}</h3>
            </div>
          </template>
          <template v-slot:headerAction>
            <div class="timer font-weight-bold text-danger" style="font-size: 20px">
              {{ formattedTime }}
            </div>
          </template>
          <b-progress :value="progress" max="100" class="mb-3"></b-progress>
          <div class="p-5" style="font-size: 1.1rem;">
            <form>
              <b-row>
                <b-col sm="12">
                  <b-form-group v-if="currentQuestion && currentQuestion.TipoRespuesta === 'SeleccionMultiple'"
                                v-slot="{ ariaDescribedby }" :label="currentQuestion.Enunciado"
                                :label-class="'font-weight-bold'">
                    <b-form-radio class="form-res" sm="12" v-for="res in currentQuestion.Respuestas" :key="res.ID"
                                  :aria-describedby="ariaDescribedby" :value="res.ID"
                                  v-model="userAnswers.respuestas[currentQuestion.ID]">
                      {{ res.TextoRespuesta }}
                    </b-form-radio>
                  </b-form-group>

                  <b-form-group v-else-if="currentQuestion && currentQuestion.TipoRespuesta === 'TextoLibre'"
                                :label="currentQuestion.Enunciado" :label-class="'font-weight-bold'">
                    <b-form-textarea v-model="userAnswers.respuestas[currentQuestion.ID]" :rows="3" :max-rows="6">
                    </b-form-textarea>
                  </b-form-group>

                  <b-form-group v-else-if="currentQuestion && currentQuestion.TipoRespuesta === 'MultipleRespuesta'"
                                :label="currentQuestion.Enunciado" :label-class="'font-weight-bold'">
                    <b-form-checkbox-group v-model="userAnswers.respuestas[currentQuestion.ID]">
                      <b-form-checkbox class="form-res" v-for="res in currentQuestion.Respuestas" :key="res.ID"
                                       :value="res.ID">
                        {{ res.TextoRespuesta }}
                      </b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>

                  <b-form-group v-else-if="currentQuestion && currentQuestion.TipoRespuesta === 'VerdaderoFalso'"
                                :label="currentQuestion.Enunciado" :label-class="'font-weight-bold'">
                    <b-form-radio class="form-res" value="true" v-model="userAnswers.respuestas[currentQuestion.ID]">
                      Verdadero
                    </b-form-radio>
                    <b-form-radio class="form-res" value="false" v-model="userAnswers.respuestas[currentQuestion.ID]">
                      Falso
                    </b-form-radio>
                  </b-form-group>
                </b-col>
              </b-row>
            </form>
          </div>
          <template v-slot:footer>
            <div class="d-flex justify-content-between">
              <vs-button :disabled="!isCurrentQuestionAnswered" variant="primary" :loading="LoadingNextPregunta"
                        v-if="currentQuestionIndex !== ListEvaluacion.length - 1"
                        @click="nextQuestion">
                Siguiente
              </vs-button>
              <vs-button :disabled="evaluacionTerminada || !isCurrentQuestionAnswered" variant="primary"
                        v-if="currentQuestionIndex === ListEvaluacion.length - 1"
                        @click="submitForm">
                Finalizar
              </vs-button>
            </div>
          </template>
        </card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Swal from "sweetalert2";

export default {
  data() {
    return {
      PersonaId: null,
      EvaluacionId: null,
      ListEvaluacion: [],
      TituloEvaluacion: null,
      userAnswers: {
        fechaInicioCompleto: null,
        respuestas: {}
      },
      currentQuestionIndex: 0, // Índice de la pregunta actual
      timeRemaining: 900, // 900 segundos = 15 minutos
      timer: null,
      evaluacionTerminada: false,
      CerrarEvaluacion: false,
      LoadingNextPregunta: false
    };
  },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.timeRemaining / 60);
      const seconds = this.timeRemaining % 60;
      return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    },
    // Obtener la pregunta actual basada en el índice
    currentQuestion() {
      return this.ListEvaluacion[this.currentQuestionIndex];
    },
    isCurrentQuestionAnswered() {
      if (!this.currentQuestion) {
        return false;
      }

      const currentAnswer = this.userAnswers.respuestas[this.currentQuestion.ID];

      if (this.currentQuestion.TipoRespuesta === "SeleccionMultiple" ||
          this.currentQuestion.TipoRespuesta === "VerdaderoFalso") {
        return currentAnswer !== undefined; // Respuesta seleccionada
      }

      if (this.currentQuestion.TipoRespuesta === "TextoLibre") {
        return currentAnswer && currentAnswer.trim().length > 0; // Texto no vacío
      }

      if (this.currentQuestion.TipoRespuesta === "MultipleRespuesta") {
        return currentAnswer && currentAnswer.length > 0; // Al menos una opción seleccionada
      }

      return false;
    },
    progress() {
      return (this.currentQuestionIndex / this.ListEvaluacion.length) * 100;
    }
  },
  async mounted() {
    this.EvaluacionId = this.$route.params.id;
    this.PersonaId = JSON.parse(localStorage.getItem("setPersonaAct")).id;
    await this.getEvaluacion(this.$route.params.id);
    window.addEventListener('beforeunload', this.preventReload);
    this.startTimer();
  },
  methods: {
    preventReload(event) {
      event.preventDefault();
      event.returnValue = "Si recargas la página, perderás tu progreso.";
    },
    async getEvaluacion(id) {

      let response = await this.$store.dispatch("hl_get", {
        path: `EvaluacionesAcademia/ObtenerEvaluacion/${id}/persona/${this.PersonaId}`,
      });
      if (response.respuesta) {
        this.ListEvaluacion = response.data.Preguntas;
        this.TituloEvaluacion = response.data.Informacion.Titulo;
        this.timeRemaining = response.data.Informacion.Tiempo * 60;
      } else {
        await Swal.fire("Error!", response.mensaje, "error");
        this.CerrarEvaluacion = true;
        await this.$router.push(`/helex/Ayuda/Academia/InformacionEvaluacion/${this.EvaluacionId}`);
      }
    },
    async nextQuestion() {
      if (this.currentQuestionIndex < this.ListEvaluacion.length - 1) {
        await this.guardarRespuesta(); // Guarda la respuesta antes de avanzar
        this.currentQuestionIndex++;
      }
    },
    async guardarRespuesta() {
      try {
        this.LoadingNextPregunta = true;
        let preguntaId = this.currentQuestion.ID;
        let respuesta = this.userAnswers.respuestas[preguntaId];

        if (!respuesta) return; // No guarda si no hay respuesta

        let requestBody = {
          PreguntaId: preguntaId,
          Respuesta: Array.isArray(respuesta) ? respuesta.join(',') : respuesta
        };

        let url = `EvaluacionesAcademia/GuardarRespuestaEvaluacion/${this.PersonaId}/evaluacion/${this.EvaluacionId}`;

        await this.$store.dispatch('hl_post', {
          path: url,
          data: requestBody
        });
        this.LoadingNextPregunta = false;

      } catch (error) {
        console.error("Error al guardar respuesta:", error);
      }
    },
    async submitForm() {
      try {
        this.evaluacionTerminada = true;
        this.CerrarEvaluacion = true;

        await this.guardarRespuesta();
        this.$store.dispatch('hl_post', {
          path: `EvaluacionesAcademia/FinalizarEvaluacion/${this.PersonaId}/${this.EvaluacionId}`,
        }).then(response => {
          if (response.respuesta) {
            this.$router.push(`/helex/Ayuda/Academia/InformacionEvaluacion/${this.EvaluacionId}`);
          } else {
            Swal.fire({
              title: 'No se pudo terminar la evaluacion',
              text: response.mensaje,
              icon: 'error',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Salir'
            }).then(async (result) => {
              if (result.isConfirmed) {
                await this.$router.push(`/helex/Ayuda/Academia/InformacionEvaluacion/${this.EvaluacionId}`);
              }
            })
          }
        })

      } catch (error) {
        console.log("error capturado: ", error);
      }
    },
    startTimer() {
      this.timer = setInterval(() => {
        if (this.timeRemaining > 0) {
          this.timeRemaining--;
        } else {
          clearInterval(this.timer);
          this.timeUp();
        }
      }, 1000);
    },
    timeUp() {
      this.submitForm(); // Llama al método para finalizar la evaluación automáticamente
    },
  },
  beforeDestroy() {
    // Detén el temporizador si el componente se desmonta
    window.removeEventListener('beforeunload', this.preventReload);
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.evaluacionTerminada) {
      next();
      return;
    }
    Swal.fire({
      title: "¿Salir de la evaluación?",
      text: "Si sales, la evaluación se dará por terminada.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Salir",
      cancelButtonText: "Quedarme"
    }).then(result => {
      if (result.isConfirmed) {
        next();
      } else {
        next(false);
      }
    });
  },
};

</script>

<style scoped>
.form-res {
  border: 1px rgb(80, 80, 80) solid;
  border-radius: 5px;
  padding: 3px 35px;
  margin: 5px;
  width: 100%;
}
</style>